/* ==========================================================================
   Opticiens Conseil - Store Locator Bridge
   Asset: assets/opticiens-store-locator-bridge.js

   Purpose:
   1. Product pages: redirect the postal-code mini form to the existing locator.
   2. /a/magasins: if URL has ?q=POSTAL, auto-fill the locator search input.
   ========================================================================== */

(function () {
  'use strict';

  function getQueryParam(name) {
    var params = new URLSearchParams(window.location.search);
    return params.get(name) || '';
  }

  function buildLocatorUrl(baseUrl, query) {
    var url = (baseUrl || '/a/magasins').split('#')[0];
    var value = String(query || '').trim();

    if (value) {
      url += (url.indexOf('?') === -1 ? '?' : '&') + 'q=' + encodeURIComponent(value);
    }

    return url + '#liste-des-boutiques';
  }

  function initProductMiniLocator() {
    document.querySelectorAll('[data-product-store-locator]').forEach(function (container) {
      if (container.dataset.opticiensLocatorReady === 'true') return;
      container.dataset.opticiensLocatorReady = 'true';

      var input = container.querySelector('.product-store-locator__input');
      var searchButton = container.querySelector('.product-store-locator__search');
      var fullLocatorLink = container.querySelector('.product-store-locator__link');
      var message = container.querySelector('.product-store-locator__message');
      var locatorUrl = container.getAttribute('data-store-locator-url') || '/a/magasins';

      function submitLocatorSearch() {
        var value = input ? input.value.trim() : '';

        if (!value) {
          if (message) message.classList.add('is-visible');
          if (input) input.focus();
          return;
        }

        window.location.href = buildLocatorUrl(locatorUrl, value);
      }

      if (searchButton) {
        searchButton.addEventListener('click', submitLocatorSearch);
      }

      if (input) {
        input.addEventListener('input', function () {
          if (message) message.classList.remove('is-visible');
        });

        input.addEventListener('keydown', function (event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            submitLocatorSearch();
          }
        });
      }

      if (fullLocatorLink) {
        fullLocatorLink.addEventListener('click', function (event) {
          var value = input ? input.value.trim() : '';
          if (!value) return;

          event.preventDefault();
          window.location.href = buildLocatorUrl(locatorUrl, value);
        });
      }
    });
  }

  function triggerInputSearch(input, query) {
    input.focus();
    input.value = query;

    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));

    var enterEvent = new KeyboardEvent('keydown', {
      key: 'Enter',
      code: 'Enter',
      keyCode: 13,
      which: 13,
      bubbles: true
    });

    input.dispatchEvent(enterEvent);
  }

  function initLocatorLandingAutofill() {
    var query = getQueryParam('q') || getQueryParam('postal') || getQueryParam('postcode');
    if (!query) return;

    var attempts = 0;
    var maxAttempts = 50;

    var timer = window.setInterval(function () {
      attempts += 1;

      var input = document.querySelector(
        '.mapboxgl-ctrl-geocoder input, .simple-search input, [data-map-target="search"] input'
      );

      if (input) {
        window.clearInterval(timer);
        triggerInputSearch(input, query);

        window.setTimeout(function () {
          var firstSuggestion = document.querySelector(
            '.suggestions li a, .mapboxgl-ctrl-geocoder--suggestion, .mapboxgl-ctrl-geocoder .suggestions > li'
          );

          if (firstSuggestion) {
            firstSuggestion.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
          }
        }, 700);

        return;
      }

      if (attempts >= maxAttempts) {
        window.clearInterval(timer);
      }
    }, 200);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initProductMiniLocator();
    initLocatorLandingAutofill();
  });

  document.addEventListener('shopify:section:load', initProductMiniLocator);
})();
